
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-teams",
      function () {
        return require("private-next-pages/for-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-teams"])
      });
    }
  